﻿var $ = require('jquery');

class Utils {
    static getLinkUrl(list, rel) {
        var result,
            url = '';

        if (list) {
            result = $.grep(list, function(e) { return e.rel === rel; });
            url = result.length ? result[0].href : '';
        }
        return url;
    }

    static createDiv(className, html) {
        return $('<div/>', {'class': className, 'html': html});
    }
    static languages() {
        return {
            'en': {
                code: 'EN',
                string: 'English'
            },
            'ga': {
                code: 'GA',
                string: 'Gaeilge'
            }
        };
    }
    static keys() {
        return {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };
    }
    static postcodeMatch() {
        return {
            UNDEFINED: 0,
            POSTCODE_APPENDED: 100,
            POSTCODE_VALIDATED: 110,
            POSTCODE_AMENDED: 120,
            ADDRESS_AMENDED: 130,
            POSTCODE_AND_ADDRESS_AMENDED: 140,
            POSTCODE_NOT_VALIDATED: 150,
            POSTCODE_NOT_APPENDED: 200,
            POSTCODE_RETIRED: 210,
            NUA: 300,
            PARTIAL: 400,
            INCOMPLETE: 500,
            NO_ADDRESS_MATCH: 550,
            FOREIGN: 600,
            INVALID: 700
        };
    }
}

class Autocomplete {
    constructor(el, options) {
        var that = this,
            defaults = {
                ajaxSettings: {},
                autoSelectFirst: true,
                appendTo: '.autoaddress-control',
                serviceUrl: null,
                lookup: null,
                onSelect: null,
                width: 'auto',
                minChars: 3,
                defaultSearch: false,
                maxHeight: 300,
                deferRequestBy: 0,
                params: {},
                formatResult: this.formatResult,
                delimiter: null,
                zIndex: 9999,
                type: 'GET',
                noCache: false,
                onSearchStart: $.noop,
                onSearchComplete: $.noop,
                onSearchError: $.noop,
                preserveInput: false,
                containerClass: 'autoaddress-autocomplete',
                dataType: 'text',
                currentRequest: null,
                triggerSelectOnValidInput: false,
                preventBadQueries: true,
                paramName: 'query',
                transformResult: function(response) {
                    return typeof response === 'string' ? JSON.parse(response) : response;
                },
                showNoSuggestionNotice: false,
                noSuggestionNotice: 'No results',
                orientation: 'bottom',
                forceFixPosition: false
            };

        // Shared variables:
        that.element = el;
        that.el = $(el);
        that.suggestions = [];
        that.badQueries = [];
        that.selectedIndex = -1;
        that.currentValue = that.element.value;
        that.intervalId = 0;
        that.cachedResponse = {};
        that.onChangeInterval = null;
        that.onChange = null;
        that.isLocal = false;
        that.suggestionsContainer = null;
        that.noSuggestionsContainer = null;
        that.options = $.extend({}, defaults, options);
        that.classes = {
            selected: 'selected',
            suggestion: 'autoaddress-suggestion'
        };
        that.hint = null;
        that.hintValue = '';
        that.selection = null;

        // Initialize and set options:
        that.initialize();
        that.setOptions(options);
    }

    createNode(containerClass) {
        var div = document.createElement('div');

        div.className = containerClass;
        div.style.position = 'absolute';
        div.style.display = 'none';
        return div;
    }

    formatResult(suggestion) {
        var htmlSafeString = suggestion.value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');

        return htmlSafeString;
    }

    initialize() {
        var that = this,
            suggestionSelector = '.' + this.classes.suggestion,
            selected = this.classes.selected,
            options = this.options;

        // Remove autocomplete attribute to prevent native suggestions:
        this.element.setAttribute('autocomplete', 'off');

        // html() deals with many types: htmlString or Element or Array or jQuery
        this.noSuggestionsContainer = $('<div class="autocomplete-no-suggestion"></div>')
            .html(this.options.noSuggestionNotice).get(0);

        this.suggestionsContainer = this.createNode(options.containerClass);

        var container = $(this.suggestionsContainer);

        container.appendTo(options.appendTo);
        // Only set width if it was provided:
        if (options.width !== 'auto') {
            container.width(options.width);
        }

        // Listen for mouse over event on suggestions list:
        container.on('mouseover.autocomplete', suggestionSelector, function() {
            that.activate($(this).data('index'));
        });

        // Deselect active element when mouse leaves suggestions container:
        container.on('mouseout.autocomplete', function() {
            that.selectedIndex = -1;
            container.children('.' + selected).removeClass(selected);
        });

        // Listen for click event on suggestions list:
        container.on('click.autocomplete', suggestionSelector, function() {
            that.select($(this).data('index'));
        });

        that.fixPositionCapture = function() {
            if (that.visible) {
                that.fixPosition();
            }
        };

        this.el.on('keydown.autocomplete', function(e) { that.onKeyPress(e); });
        this.el.on('keyup.autocomplete', function(e) { that.onKeyUp(e); });
        this.el.on('blur.autocomplete', function() { that.onBlur(); });
        this.el.on('focus.autocomplete', function() { that.onFocus(); });
        this.el.on('change.autocomplete', function(e) { that.onKeyUp(e); });
        this.el.on('input.autocomplete', function(e) { that.onKeyUp(e);});
    }

    onFocus() {
        var that = this;

        that.fixPosition();
    }

    onBlur() {
        this.enableKillerFn();
    }

    setOptions(suppliedOptions) {
        var that = this,
            options = that.options;

        $.extend(options, suppliedOptions);

        that.isLocal = Array.isArray(options.lookup);

        options.orientation = that.validateOrientation(options.orientation, 'bottom');

        // Adjust height, width and z-index:
        $(that.suggestionsContainer).css({
            'width': options.width + 'px',
            'z-index': options.zIndex
        });
    }

    clearCache() {
        this.cachedResponse = {};
        this.badQueries = [];
    }

    clear() {
        this.clearCache();
        this.currentValue = '';
        this.suggestions = [];
    }

    disable() {
        var that = this;

        that.disabled = true;
        clearInterval(that.onChangeInterval);
        if (that.currentRequest) {
            that.currentRequest.abort();
        }
    }

    enable() {
        this.disabled = false;
    }

    fixPosition() {
        // Use only when container has already its content

        var that = this,
            $container = $(that.suggestionsContainer),
            containerParent = $container.parent().get(0);

        // Fix position automatically when appended to body.
        // In other cases force parameter must be given.
        if (containerParent !== document.body && !that.options.forceFixPosition) {
            return;
        }

        // Choose orientation
        var orientation = that.options.orientation,
            containerHeight = $container.outerHeight(),
            height = that.el.outerHeight(),
            offset = that.el.offset(),
            styles = { 'top': offset.top, 'left': offset.left };

        if (orientation === 'auto') {
            var viewPortHeight = $(window).height(),
                scrollTop = $(window).scrollTop(),
                topOverflow = -scrollTop + offset.top - containerHeight,
                bottomOverflow = scrollTop + viewPortHeight - (offset.top + height + containerHeight);

            orientation = (Math.max(topOverflow, bottomOverflow) === topOverflow) ? 'top' : 'bottom';
        }

        if (orientation === 'top') {
            styles.top += -containerHeight;
        } else {
            styles.top += height;
        }

        // If container is not positioned to body,
        // correct its position using offset parent offset
        if (containerParent !== document.body) {
            var opacity = $container.css('opacity');

            if (!that.visible) {
                $container.css('opacity', 0).show();
            }

            var parentOffsetDiff = $container.offsetParent().offset();

            styles.top -= parentOffsetDiff.top;
            styles.left -= parentOffsetDiff.left;

            if (!that.visible) {
                $container.css('opacity', opacity).hide();
            }
        }

        // -2px to account for suggestions border.
        if (that.options.width === 'auto') {
            styles.width = (that.el.outerWidth() - 2) + 'px';
        }

        $container.css(styles);
    }

    enableKillerFn() {
        var that = this;

        $(document).on('click.autocomplete', function(e) {
            if ($(e.target).closest('.' + that.options.containerClass).length === 0) {
                that.killSuggestions();
                that.disableKillerFn();
            }
        });
    }

    disableKillerFn() {
        var that = this;

        $(document).off('click.autocomplete', function(e) {
            if ($(e.target).closest('.' + that.options.containerClass).length === 0) {
                that.killSuggestions();
                that.disableKillerFn();
            }
        });
    }

    killSuggestions() {
        var that = this;

        that.stopKillSuggestions();
        that.intervalId = window.setInterval(function() {
            that.hide();
            that.stopKillSuggestions();
        }, 50);
    }

    stopKillSuggestions() {
        window.clearInterval(this.intervalId);
    }

    isCursorAtEnd() {
        var that = this,
            valLength = that.el.val().length,
            selectionStart = that.element.selectionStart,
            range;

        if (typeof selectionStart === 'number') {
            return selectionStart === valLength;
        }
        if (document.selection) {
            range = document.selection.createRange();
            range.moveStart('character', -valLength);
            return valLength === range.text.length;
        }
        return true;
    }

    onKeyPress(e) {
        var that = this;

        // If suggestions are hidden and user presses arrow down, display suggestions:
        if (!that.disabled && !that.visible && e.which === Utils.keys().DOWN && that.currentValue) {
            return;
        }

        if (that.disabled || !that.visible) {
            return;
        }

        switch (e.which) {
        case Utils.keys().ESC:
            that.hide();
            return;
        case Utils.keys().RIGHT:
            if (that.hint && that.options.onHint && that.isCursorAtEnd()) {
                that.selectHint();
                break;
            }
            return;
        case Utils.keys().TAB:
            that.el.val(that.currentValue);
            that.hide();
            return;
        case Utils.keys().RETURN:
            if (that.selectedIndex === -1) {
                that.hide();
                return;
            }
            that.select(that.selectedIndex);
            break;
        case Utils.keys().UP:
            that.moveUp();
            break;
        case Utils.keys().DOWN:
            that.moveDown();
            break;
        default:
            return;
        }

        // Cancel event if function did not return:
        e.stopImmediatePropagation();
        e.preventDefault();
    }

    onKeyUp(e) {
        var that = this;

        if (that.disabled) {
            return;
        }

        switch (e.which) {
        case Utils.keys().UP:
        case Utils.keys().DOWN:
            return;
        }

        clearInterval(that.onChangeInterval);
        if (that.currentValue !== that.el.val()) {
            if (that.options.deferRequestBy > 0) {
                // Defer lookup in case when value changes very quickly:
                that.onChangeInterval = setInterval(function() {
                    that.onValueChange();
                }, that.options.deferRequestBy);
            } else {
                that.onValueChange();
            }
        }
    }

    onValueChange() {
        var that = this,
            options = that.options,
            value = that.el.val(),
            query = that.getQuery(value),
            index;

        if (that.selection && that.currentValue !== query) {
            that.selection = null;
            (options.onInvalidateSelection || $.noop).call(that.element);
        }

        clearInterval(that.onChangeInterval);
        that.currentValue = value;
        that.selectedIndex = -1;

        // Check existing suggestion for the match before proceeding:
        if (options.triggerSelectOnValidInput) {
            index = that.findSuggestionIndex(query);
            if (index !== -1) {
                that.select(index);
                return;
            }
        }

        if (query.length < options.minChars) {
            that.hide();
        } else {
            that.getSuggestions(query);
        }
    }

    findSuggestionIndex(query) {
        var that = this,
            index = -1,
            queryLowerCase = query.toLowerCase();

        $.each(that.suggestions, function(i, suggestion) {
            if (suggestion.value.toLowerCase() === queryLowerCase) {
                index = i;
                return false;
            }
            return true;
        });

        return index;
    }

    getQuery(value) {
        var delimiter = this.options.delimiter;

        if (!delimiter) {
            return value;
        }
        var parts = value.split(delimiter);

        return parts[parts.length - 1].trim();
    }

    getSuggestions(q) {
        var that = this,
            options = that.options,
            lastCharacter = q.substr(q.length - 1);

        options.params[options.paramName] = q;
        if (lastCharacter === '.') {
            return;
        }
        if (options.onSearchStart.call(that.element, options.params) === false) {
            return;
        }

        if ($.isFunction(options.lookup)) {
            options.lookup(q,
                function(data) {
                    that.suggestions = data.suggestions;
                    that.suggest();
                });
            return;
        }
    }

    isBadQuery(q) {
        if (!this.options.preventBadQueries) {
            return false;
        }

        var badQueries = this.badQueries,
            i = badQueries.length;

        while (i--) {
            if (q.indexOf(badQueries[i]) === 0) {
                return true;
            }
        }

        return false;
    }

    hide() {
        var that = this,
            container = $(that.suggestionsContainer);

        if ($.isFunction(that.options.onHide) && that.visible) {
            that.options.onHide.call(that.element, container);
        }

        that.visible = false;
        that.selectedIndex = -1;
        clearInterval(that.onChangeInterval);
        $(that.suggestionsContainer).hide();
        $(that.suggestionsContainer).empty();
    }

    getSuggestionsHtml(options, suggestionsArray, className, currentValue, value, defaultSearch) {
        if (suggestionsArray.length < 1) {
            return '';
        }

        var html = '',
            that = this;

        if (defaultSearch) {
            html += '<div class="' +
                className +
                ' autoaddress-searchTerm autoaddress-defaultSearch" data-index="0">' +
                that.formatResult(suggestionsArray[0]) +
                '</div>';

            $.each(suggestionsArray, function(i, suggestion) {
                if (i > 0) {
                    html += '<div class="' +
                    className +
                    ' autoaddress-defaultSearch" data-index="' + i + '">' +
                    that.formatResult(suggestion) +
                    '</div>';
                }
            });
        } else {
            if (suggestionsArray.length === 1) {
                html += '<div class="' +
                    className +
                    ' autoaddress-searchTerm autoaddress-search" data-index="0">' +
                    that.formatResult(suggestionsArray[0]) +
                    '</div>';
            } else {
                suggestionsArray.shift();
                $.each(suggestionsArray, function(i, suggestion) {
                    html += '<div class="' +
                        className +
                        ' autoaddress-search" data-index="' + i + '">' +
                        that.formatResult(suggestion) +
                        '</div>';
                });
            }
        }

        return html;
    }

    suggest() {
        if (this.suggestions.length === 0) {
            if (this.options.showNoSuggestionNotice) {
                this.noSuggestions();
            } else {
                this.hide();
            }
            return;
        }

        var that = this,
            options = that.options,
            value = that.getQuery(that.currentValue),
            className = that.classes.suggestion,
            classSelected = that.classes.selected,
            container = $(that.suggestionsContainer),
            noSuggestionsContainer = $(that.noSuggestionsContainer),
            beforeRender = options.beforeRender,
            index;

        if (options.triggerSelectOnValidInput) {
            index = that.findSuggestionIndex(value);
            if (index !== -1) {
                that.select(index);
                return;
            }
        }

        if (!that.currentValue) {
            that.suggestions = [];
            container.hide();
            that.visible = false;
        } else {
            var html = that.getSuggestionsHtml(
                options,
                that.suggestions,
                className,
                that.currentValue,
                value,
                that.options.defaultSearch);

            noSuggestionsContainer.detach();
            container.html(html);

            if ($.isFunction(beforeRender)) {
                beforeRender.call(that.element, container);
            }

            that.fixPosition();
            container.show();

            // Select first value by default:
            if (options.autoSelectFirst) {
                that.selectedIndex = 0;
                container.scrollTop(0);
                container.children('.' + className).first().addClass(classSelected);
            }

            that.visible = true;
        }
    }

    noSuggestions() {
        var that = this,
            container = $(that.suggestionsContainer),
            noSuggestionsContainer = $(that.noSuggestionsContainer);

        // Some explicit steps. Be careful here as it easy to get
        // noSuggestionsContainer removed from DOM if not detached properly.
        noSuggestionsContainer.detach();
        container.empty(); // clean suggestions if any
        container.append(noSuggestionsContainer);

        that.fixPosition();

        container.show();
        that.visible = true;
    }

    validateOrientation(orientation, fallback) {
        orientation = (orientation || '').trim().toLowerCase();

        if (['auto', 'bottom', 'top'].indexOf(orientation) === -1) {
            orientation = fallback;
        }

        return orientation;
    }

    activate(index) {
        var that = this,
            activeItem,
            selected = that.classes.selected,
            container = $(that.suggestionsContainer),
            children = container.find('.' + that.classes.suggestion);

        container.find('.' + selected).removeClass(selected);

        that.selectedIndex = index;

        if (that.selectedIndex !== -1 && children.length > that.selectedIndex) {
            activeItem = children.get(that.selectedIndex);
            $(activeItem).addClass(selected);
            return activeItem;
        }

        return null;
    }

    selectHint() {
        var that = this,
            i = that.suggestions.indexOf(that.hint);

        that.select(i);
    }

    select(i) {
        var that = this;

        that.hide();
        that.onSelect(i);
    }

    moveUp() {
        var that = this;

        if (that.selectedIndex === -1) {
            return;
        }

        if (that.selectedIndex === 0) {
            $(that.suggestionsContainer).children().first().removeClass(that.classes.selected);
            that.selectedIndex = -1;
            that.el.val(that.currentValue);
            return;
        }

        that.adjustScroll(that.selectedIndex - 1);
    }

    moveDown() {
        var that = this;

        if (that.selectedIndex === (that.suggestions.length - 1)) {
            return;
        }

        that.adjustScroll(that.selectedIndex + 1);
    }

    adjustScroll(index) {
        var that = this,
            activeItem = that.activate(index);

        if (!activeItem) {
            return;
        }

        var heightDelta = $(activeItem).outerHeight();
        var offsetTop = activeItem.offsetTop;
        var upperBound = $(that.suggestionsContainer).scrollTop();
        var lowerBound = upperBound + that.options.maxHeight - heightDelta;

        if (offsetTop < upperBound) {
            $(that.suggestionsContainer).scrollTop(offsetTop);
        } else if (offsetTop > lowerBound) {
            $(that.suggestionsContainer).scrollTop(offsetTop - that.options.maxHeight + heightDelta);
        }

        if (!that.options.preserveInput) {
            that.el.val(that.getValue(that.suggestions[index].value));
        }
    }

    onSelect(index) {
        var that = this,
            onSelectCallback = that.options.onSelect,
            suggestion = that.suggestions[index];

        that.currentValue = that.getValue(suggestion.value);

        if (that.currentValue !== that.el.val() && !that.options.preserveInput) {
            that.el.val(that.currentValue);
        }

        that.suggestions = [];
        that.selection = suggestion;

        if ($.isFunction(onSelectCallback)) {
            onSelectCallback.call(that.element, suggestion);
        }
    }

    getValue(value) {
        var that = this,
            delimiter = that.options.delimiter;

        if (!delimiter) {
            return value;
        }

        var currentValue = that.currentValue;
        var parts = currentValue.split(delimiter);

        if (parts.length === 1) {
            return value;
        }

        return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
    }

    dispose() {
        var that = this;

        that.el.off('.autocomplete').removeData('autocomplete');
        that.disableKillerFn();
        $(window).off('resize.autocomplete', that.fixPositionCapture);
        $(that.suggestionsContainer).remove();
    }
}

class AutoaddressTabs {
    constructor(el, options) {
        var $el = $(el),
            defaults = {
                fadeIn: false,
                hideHash: true,
                selectedTab: 1
            },
            ul = $el.children('ul'),
            tab = ul.find('a'),
            div = $('> div', $el),
            that = this;

        this.settings = $.extend({}, defaults, options);

        tab.on('click', function(e) {
            var filterHash = div.removeClass('selected').filter('[name=' + '"' + this.hash + '"' + ']');

            tab.removeClass('selected').filter(this).addClass('selected');
            // option: fade in divs
            (that.settings.fadeIn) ? filterHash.hide().addClass('selected').fadeIn() : filterHash.addClass('selected');
            // option: hide hash change
            that.settings.hideHash && e.preventDefault();
        });

        this.settings.selectedTab && tab.eq(this.settings.selectedTab - 1).click();
    }
}

export default class Autoaddress {
    constructor(element, options) {
        this.$ = $;
        this.element = this.$(element);
        this.settings = this.$.extend({}, Autoaddress.defaults(), options);
        this.api =
        {
            url: {
                byFindAddress: [this.settings.api_domain, 'findaddress'].join('/'),
                autoComplete: [this.settings.api_domain, 'autocomplete'].join('/')
            }
        };

        this.language = this.settings.language;
        this.country = this.settings.country;
        this.geographicAddress = this.settings.geographicAddress;
        this.vanityMode = this.settings.vanityMode;
        this.addressElements = this.settings.addressElements;
        this.addressProfile = this.settings.addressProfile;
        this.limit = this.settings.optionsLimit;
        this.displayBusinessListings = this.settings.displayBusinessListings;
        this.defaultSearch = this.settings.defaultSearch;
        this.options = [];
        this.backUrlList = [];
        this.nextUrl = '';
        this.hasTabs = false;
        this.transactionId = null;
        this.selectedOption = -1;

        this.$container = undefined;
        this.$searchInput = undefined;
        this.$searchButton = undefined;
        this.$languageSelect = undefined;
        this.$optionsContainer = undefined;
        this.$optionsHeader = undefined;
        this.$messageContainer = undefined;
        this.$backLink = undefined;

        this.addContainerWrapper().addSearchField().addSearchButton().addAutoComplete();
        if (this.$.isFunction(this.settings.onInitialize)) {
            this.settings.onInitialize.call(this);
        }
    }

    createDiv(className, html) {
        'use strict';
        return this.$('<div/>',
            {
                'class': className,
                'html': html
            });
    }

    addContainerWrapper() {
        'use strict';
        this.$container = this.createDiv(this.settings.containerClass).appendTo(this.element);
        if (this.settings.width !== 'auto') {
            this.$container.width(this.settings.width);
        }
        return this;
    }

    addSearchField() {
        'use strict';
        var self = this;

        this.$searchInput = this.$('<input/>',
            {
                'placeholder': this.getLabel('placeHolder'),
                'type': 'text',
                'spellcheck': false
            })
            .appendTo(this.$container)
            .addClass(this.settings.searchInputClass)
            .on('input.AutoAddress propertychange.AutoAddress',
                function() {
                    var searchValue = self.$(this).val();

                    self.clearErrorMessage();

                    if (self.$.isFunction(self.settings.onChange)) {
                        self.settings.onChange.call(self, searchValue);
                    }
                    if (searchValue === '') {
                        if (self.$.isFunction(self.settings.onClear)) {
                            self.settings.onClear.call(self);
                        }
                    }
                    if (self.options) {
                        self.setDefaultState();
                        self.clearBackHistory();
                    }
                })
            .on('focus.AutoAddress',
                function() {
                    if (self.$.isFunction(self.settings.onFocus)) {
                        self.settings.onFocus.call(self);
                    }
                })
            .on('keypress.AutoAddress',
                function(e) {
                    if (e.which === Utils.keys().RETURN) {
                        e.preventDefault();
                        if (self.selectedOption !== -1) {
                            self.optionOnSelect(self.selectedOption, self.options);
                        } else {
                            self.searchQuery(self.$searchInput.val());
                        }
                    }
                })
            .on('keydown.AutoAddress',
                function(e) {
                    if (e.which === Utils.keys().ESC || e.which === Utils.keys().TAB) {
                        self.setDefaultState();
                        self.clearBackHistory();
                        if (e.which === Utils.keys().ESC) {
                            self.clearAddress();
                        }
                    }
                    if (self.options && self.options.length) {
                        if (e.which === Utils.keys().DOWN) {
                            e.preventDefault();
                            self.moveDown();
                        }
                        if (e.which === Utils.keys().UP) {
                            e.preventDefault();
                            self.moveUp();
                        }
                    }
                });
        return this;
    }

    addSearchButton() {
        'use strict';
        var self = this;

        this.$searchButton = this.$('<button/>',
            {
                'html': this.getLabel('searchButton'),
                'tabIndex': -1
            })
            .addClass(this.settings.searchButtonClass).appendTo(this.$container)
            .on('click',
                function(e) {
                    e.preventDefault();
                    self.searchQuery(self.$searchInput.val());
                });
        return this;
    }

    addAutoComplete() {
        'use strict';
        var self = this;

        if (this.settings.autocomplete) {
            this.autoComplete = new Autocomplete(this.$searchInput[0], {
                minChars: this.settings.autocompleteMinChars,
                defaultSearch: this.settings.defaultSearch,
                appendTo: this.$container,
                containerClass: this.settings.autocompleteContainer,
                lookup: function(query, done) {
                    self.autoCompleteSearch(query, done);
                },
                onSelect: function(item) {
                    if (self.$.isFunction(self.settings.onAutoCompleteSelected)) {
                        self.settings.onAutoCompleteSelected.call(self.element, item);
                    }

                    if (item.data === 'auto') {
                        self.findAddress(item.value);
                    } else {
                        self.findNextUrl(self.getLinkUrl(item.data.links, 'next'));
                    }
                    return self;
                }
            });
        }
        return this;
    }

    moveDown() {
        'use strict';

        if (this.selectedOption === (this.options.length - 1)) {
            return;
        }
        this.adjustScroll(this.selectedOption + 1);
    }

    moveUp() {
        'use strict';

        if (this.selectedOption === -1) {
            return;
        }

        if (this.selectedOption === 0) {
            this.$optionsContainer.find('.' + this.settings.optionsItemClass).removeClass('active');
            this.selectedOption = -1;
            return;
        }

        this.adjustScroll(this.selectedOption - 1);
    }

    activate(index) {
        'use strict';
        var activeItem,
            selected = 'active',
            children;

        if (this.hasTabs) {
            children = this.$optionsContainer.children('.selected').find('.' + this.settings.optionsItemClass);
        } else {
            children = this.$optionsContainer.find('.' + this.settings.optionsItemClass);
        }

        this.$optionsContainer.find('.' + selected).removeClass(selected);

        this.selectedOption = index;

        if (this.selectedOption !== -1 && children.length > this.selectedOption) {
            activeItem = children.get(this.selectedOption);
            this.$(activeItem).addClass(selected);
            return activeItem;
        }
        return null;
    }

    adjustScroll(index) {
        'use strict';
        var activeItem = this.activate(index),
            heightDelta,
            optionListContainer,
            offsetTop,
            upperBound,
            lowerBound;

        if (!activeItem) {
            return;
        }

        heightDelta = this.$(activeItem).outerHeight();
        optionListContainer = this.$('.' + this.settings.optionsListClass);

        if (!optionListContainer) {
            return;
        }

        offsetTop = activeItem.offsetTop;
        upperBound = optionListContainer.scrollTop();
        lowerBound = upperBound + optionListContainer.height() - heightDelta;

        if (offsetTop < upperBound) {
            optionListContainer.scrollTop(offsetTop);
        } else if (offsetTop > lowerBound) {
            optionListContainer.scrollTop(offsetTop - optionListContainer.height() + heightDelta);
        }
        return;
    }

    searchQuery(address) {
        'use strict';
        this.setDefaultState();
        if (!address) {
            this.displayErrorMessage(this.getLabel('inputRequired'));
        } else {
            this.findAddress(address);
        }
    }

    autoCompleteSearch(term, done) {
        'use strict';

        var self = this,
            addresses = [],
            suggestions = [],
            autocompleteWrapper = {},
            options = this.createAPIOptions(this.api.url.autoComplete, term);

        this.callApi(options.url,
                    function(data) {
                        var autoSuggestion;

                        if (!self.checkResponseContainsError(data)) {
                            addresses = data.options;
                            if (addresses) {
                                self.$.each(addresses,
                                    (index, value) => {
                                        var item = {
                                            value: value.displayName,
                                            data: value
                                        };

                                        suggestions.push(item);
                                    });
                            }
                            if (term.length >= self.settings.autocompleteMinChars) {
                                autoSuggestion = { value: term, data: 'auto' };
                                suggestions.unshift(autoSuggestion);
                            }
                            autocompleteWrapper = { suggestions: suggestions };
                            if (term === self.$searchInput.val()) {
                                done.call(self, autocompleteWrapper);
                            }
                        }
                    },
                    options);
        return this;
    }

    optionOnSelect(index, list) {
        'use strict';
        var selectedOption = list[index];

        this.findNextUrl(this.getLinkUrl(selectedOption.links, 'next'));
    }

    findAddress(address) {
        'use strict';
        var self = this,
            options = this.createAPIOptions(this.api.url.byFindAddress, address);

        this.displaySearchingAnimation();
        this.callApi(options.url,
                    function(data) {
                        if (!self.checkResponseContainsError(data)) {
                            self.AddressData = data;
                            self.findAddressWSCallback();
                        }
                    },
                    options);
    }

    findNextUrl(nextUrl) {
        'use strict';
        var self = this;

        this.displaySearchingAnimation();
        this.callApi(nextUrl,
                    function(data) {
                        if (!self.checkResponseContainsError(data)) {
                            self.AddressData = data;
                            self.findAddressWSCallback();
                        }
                    });
                }

    getLinkUrl(list, rel) {
        'use strict';

        var result,
            url = '';

        if (list) {
            result = this.$.grep(list, function(e) { return e.rel === rel; });
            url = result.length ? result[0].href : '';
        }
        return url;
    }

    createAPIOptions(url, term) {
        'use strict';
        var apiUrl = url + '?language=' + this.language,
            options;

        if (this.transactionId) {
            apiUrl += '&txn=' + this.transactionId;
        }

        options = {
            url: apiUrl,
            address: term
        };
        return options;
    }

    callApi(url, success, dataOptions) {
        'use strict';
        var self = this,
            apiOptions = {
                url: url,
                dataType: 'jsonp',
                timeout: 30000,
                type: 'GET',
                success: success,
                error: function(error) {
                    self.displayErrorMessage(self.getLabel('errorMessage'));
                    if (self.$.isFunction(self.settings.onLookupError)) {
                        self.settings.onLookupError.call(self, error);
                    }
                },
                complete: function() {
                    self.hideSearchingAnimation();
                }
            };

        if (dataOptions) {
            apiOptions.data = {
                key: this.settings.key,
                limit: this.limit,
                address: dataOptions.address,
                geographicAddress: this.geographicAddress,
                vanityMode: this.vanityMode,
                addressElements: this.addressElements,
                addressProfileName: this.addressProfile,
                country: this.country
            };
        }
        this.$.ajax(apiOptions);
    }

    findAddressWSCallback() {
        'use strict';
        var data = this.AddressData,
            match = data.result.code,
            options = data.options,
            matchEnum = {
                UNDEFINED: 0,
                POSTCODE_APPENDED: 100,
                POSTCODE_VALIDATED: 110,
                POSTCODE_AMENDED: 120,
                ADDRESS_AMENDED: 130,
                POSTCODE_AND_ADDRESS_AMENDED: 140,
                POSTCODE_NOT_VALIDATED: 150,
                POSTCODE_NOT_APPENDED: 200,
                POSTCODE_RETIRED: 210,
                NUA: 300,
                PARTIAL: 400,
                INCOMPLETE: 500,
                NO_ADDRESS_MATCH: 550,
                FOREIGN: 600,
                INVALID: 700
            },
            unmatched = data.unmatched,
            linksData = data.links;

        // Hide Autocomplete Options when we found a result
        $(this.autoComplete).hide();

        this.setDefaultState();
        if (this.nextUrl) {
            this.backUrlList.push(this.nextUrl);
        }

        if (!this.transactionId) {
            this.transactionId = data.input.txn;
        }

        this.nextUrl = this.getLinkUrl(linksData, 'self');

        if (this.$.isFunction(this.settings.onSearchCompleted)) {
            this.settings.onSearchCompleted.call(this, data);
        }

        if (options && options.length) {
            this.addOptionsContainer().addOptionsHeader();

            var addressOptions = this.$.grep(options, function(option) { return option.optionType.text !== 'GroupedBusiness'; }),
                businessOptions = this.$.grep(options, function(option) { return option.optionType.text === 'GroupedBusiness'; });

            if ((addressOptions.length && businessOptions.length) && (addressOptions.length > 1)) {
                if (this.displayBusinessListings) {
                    this.options = addressOptions;
                    this.addressOptions = addressOptions;
                    this.businessOptions = businessOptions;
                    this.addTabbedOptions(addressOptions, businessOptions);
                } else {
                    this.options = addressOptions;
                    this.addOptions('', addressOptions, false);
                }
            } else {
                this.options = options;
                this.addOptions('', options, false);
            }
        } else {
            this.clearBackHistory();
            switch (match) {
            case matchEnum.POSTCODE_APPENDED:
            case matchEnum.POSTCODE_AMENDED:
            case matchEnum.ADDRESS_AMENDED:
            case matchEnum.POSTCODE_VALIDATED:
            case matchEnum.POSTCODE_AND_ADDRESS_AMENDED:
                this.clearAddress();
                this.addMessageContainer(this.getLabel('addressFound'), this.settings.successMessageContainerClass);
                this.transactionId = null;
                break;
            case matchEnum.POSTCODE_NOT_APPENDED:
                this.addMessageContainer(this.getLabel('noEircodeAppended'), this.settings.infoMessageContainerClass);
                this.transactionId = null;
                break;
            case matchEnum.NUA:
                this.clearAddress();
                this.addMessageContainer(this.getLabel('nuaAddressFound'), this.settings.infoMessageContainerClass);
                this.transactionId = null;
                break;
            case matchEnum.PARTIAL:
                this.addMessageContainer(this.getLabel('partialAddress').replace('[unmatched]', '<strong>' + unmatched + '</strong>'),
                this.settings.infoMessageContainerClass);
                this.transactionId = null;
                break;
            case matchEnum.INCOMPLETE:
                this.addMessageContainer(this.getLabel('incompleteAddress'), this.settings.infoMessageContainerClass);
                this.transactionId = null;
                break;
            case matchEnum.POSTCODE_RETIRED:
            case matchEnum.NO_ADDRESS_MATCH:
            case matchEnum.FOREIGN:
            case matchEnum.INVALID:
            case matchEnum.UNDEFINED:
                this.addMessageContainer(this.getLabel('noResultFound'), this.settings.infoMessageContainerClass);
                break;
            case matchEnum.POSTCODE_NOT_VALIDATED:
                this.addMessageContainer(this.getLabel('eircodeNotValidated'), this.settings.infoMessageContainerClass);
                break;
            default:
                this.addMessageContainer(this.getLabel('noResultFound'), this.settings.infoMessageContainerClass);
            }

            if (this.$.isFunction(this.settings.onAddressFound)) {
                this.settings.onAddressFound.call(this, data);
            }

        }
        if (this.backUrlList && this.backUrlList.length) {
            this.addBackLink();
        }
    }

    addMessageContainer(message, cssClass) {
        'use strict';

        if (message) {
            this.$messageContainer = this.createDiv(cssClass, '<span></span>' + message).appendTo(this.$container);
            this.addCloseIcon();
        }
        return this;
    }

    hideMessageContainer() {
        'use strict';
        if (this.$messageContainer) {
            this.$messageContainer.remove();
        }
    }

    addOptionsContainer() {
        'use strict';
        var self = this;

        this.$optionsContainer = this.createDiv(this.settings.optionsContainerClass).appendTo(this.$container);
        if (this.settings.hoverOptionPanel) {
            this.$optionsContainer.addClass('hover');
        }
        // Deselect active element when mouse leaves suggestions container:
        this.$optionsContainer.on('mouseleave.AutoAddress',
            'ul',
            function() {
                self.selectedOption = -1;
                self.$optionsContainer.find('.active').removeClass('active');
            });
        return this;
    }

    addCloseIcon() {
        'use strict';

        this.$closeMessage = this.$('<a/>',
            {
                'href': '#',
                'tabIndex': -1
            })
            .addClass(this.settings.closeIconClass)
            .on('click',
                (e) => { //Kevin Appended
                    e.preventDefault();
                    this.hideMessageContainer();
                })
            .prependTo(this.$messageContainer);
        return this;
    }

    addBackLink() {
        // Adding Input Field to Div
        'use strict';
        var self = this;

        this.$backLink = this.$('<a/>',
            {
                'html': this.getLabel('back'),
                'href': '#',
                'tabIndex': -1
            })
            .addClass(this.settings.backLinkClass)
            .on('click',
                function(e) {
                    e.preventDefault();
                    var backUrl = self.backUrlList.pop();

                    self.nextUrl = '';
                    self.findNextUrl(backUrl);
                });
        this.$optionsContainer.after(this.$backLink);
        return this;
    }

    addOptionsHeader() {
        'use strict';
        // Adding Options Header
        if (this.settings.optionsFoundLabel) {
            this.$optionsHeader = this.createDiv(this.settings.infoMessageContainerClass,
                '<span></span>' + this.getLabel('optionsFound'));
            this.$optionsContainer.append(this.$optionsHeader);
        }
        return this;
    }

    addTabbedOptions(addressList, businessList) {
        'use strict';

        // Add Tabs
        var self = this,
            $optionsTab = this.$('<ul/>',
            {
                'class': this.settings.multiTabsClass
            });

        $optionsTab.append('<li><a href="#Residential">' + this.getLabel('addressTab') + '</a></li>');
        $optionsTab.append('<li><a href="#Commercial">' + this.getLabel('businessTab') + '</a></li>');
        this.$optionsContainer.append($optionsTab);

        $optionsTab.on('click.AutoAddress',
            'a',
            function() {
                self.$searchInput.focus();
                self.selectedOption = -1;
                if (self.$(this).attr('href') === '#Commercial') {
                    self.options = self.businessOptions;
                } else {
                    self.options = self.addressOptions;
                }
            });

        // Add Tab Panes
        this.addOptions('Residential', addressList, true);
        this.addOptions('Commercial', businessList, true);

        this.autoAddressTabs = new AutoaddressTabs(this.$('.' + this.settings.optionsContainerClass)[0]);
        this.hasTabs = true;
        return this;
    }

    addOptions(name, options, tabs) {
        'use strict';
        var self = this,
            divOptionsList;

        if (tabs) {
            divOptionsList = this.$('<div/>',
                {
                    'class': this.settings.optionsListClass + ' ' + this.settings.multiTabPaneClass,
                    'name': '#' + name
                });
        } else {
            divOptionsList = this.createDiv(this.settings.optionsListClass);
        }

        // Add options to div
        var optionItems = this.getOptionsListItems(options);

        divOptionsList.append(this.$('<ul>').append(optionItems));
        this.$optionsContainer.append(divOptionsList);

        // Listen for click event on suggestions list:
        divOptionsList.on('click',
                        'li',
                        function(e) {
                            e.preventDefault();
                            self.optionOnSelect(self.$(this).data('index'), options);
                        })
                    .on('mousewheel DOMMouseScroll',
                        function(e) {
                            if (self.$(this).height()) {
                                if (self.$(this).get(0).scrollHeight - 1 > self.$(this).height()) {
                                    var event = e.originalEvent;
                                    var d = event.wheelDelta || -event.detail;

                                    self.scrollTop += (d < 0 ? 1 : -1) * 30;
                                    e.preventDefault();
                                }
                            }
                        });
        return this;
    }

    getOptionsListItems(options) {
        'use strict';
        var self = this,
            html = '';

        this.$.each(options,
            function(i, item) {

                var input = item.displayName,
                    apartmentString = 'apartment',
                    addressDelimiter = '  -  ',
                    addressType = item.addressType ? item.addressType.code : 0,
                    optionType = item.optionType ? item.optionType.code : 0,
                    apartmentIndex = input.toLowerCase().indexOf(apartmentString),
                    addressCountIndex = input.lastIndexOf(addressDelimiter),
                    rowClass = addressType === 2000 || optionType === 0 ? 'ma-arrow' : 'ma-list',
                    addressesCount = input.substring(addressCountIndex + addressDelimiter.length);

                if (input) {
                    if (apartmentIndex >= 0 && addressCountIndex >= 0) {
                        var apartmentEndPointDelimiter = apartmentIndex + apartmentString.length;
                        var apartmentNumber = input.substring(apartmentEndPointDelimiter, addressCountIndex);

                        input = input.replace(apartmentNumber, '<strong>' + apartmentNumber + '</strong>')
                            .replace(addressesCount, '<em>' + addressesCount + '</em>');
                    } else if (addressCountIndex >= 0) {
                        var highlight = input.substring(0, addressCountIndex);

                        input = input.replace(highlight, '<strong>' + highlight + '</strong>')
                            .replace(addressesCount, '<em>' + addressesCount + '</em>');
                    }
                }
                html += '<li class="' +
                    self.settings.optionsItemClass +
                    '" data-index="' +
                    i +
                    '">' +
                    '<a tabindex="-1" href><span class="f-right ' +
                    rowClass +
                    '"></span>' +
                    input +
                    '</a></li>';
            });
        return html;
    }

    setDefaultState() {
        'use strict';

        // clear the existing list
        if (this.$optionsContainer) {
            this.$optionsContainer.remove();
        }
        if (this.$messageContainer) {
            this.$messageContainer.remove();
        }
        if (this.$backLink) {
            this.$backLink.remove();
        }
        this.hasTabs = false;
        this.selectedOption = -1;
        this.clearErrorMessage();
        this.hideSearchingAnimation();
        return this;
    }

    clearBackHistory() {
        'use strict';
        this.options = [];
        this.backUrlList.length = 0;
        this.nextUrl = '';
        return this;
    }

    clearErrorMessage() {
        'use strict';
        if (this.$messageContainer) {
            this.$messageContainer.remove();
        }
        return this;
    }

    displaySearchingAnimation() {
        'use strict';

        if (this.$.isFunction(this.settings.onSearchStart)) {
            this.settings.onSearchStart.call(this);
        }
        this.hasTabs = false;
        this.$loadingContainer = this.createDiv(this.settings.searchingClass).appendTo(this.$searchButton);
        this.$loadingContainer.append(this.createDiv(this.settings.loadingAnimationClass));
        this.$searchButton.addClass(this.settings.hideButtonTextClass);
        return this;
    }

    hideSearchingAnimation() {
        'use strict';

        if (this.$loadingContainer) {
            this.$loadingContainer.remove();
            this.$searchButton.removeClass(this.settings.hideButtonTextClass);
        }
        return this;
    }

    displayErrorMessage(error) {
        'use strict';

        if (this.$messageContainer) {
            this.clearErrorMessage();
        }

        if (!error) {
            return this;
        }

        this.setDefaultState();
        this.$messageContainer = this.createDiv(this.settings.errorMessageContainerClass, '<span></span>' + error)
                                     .appendTo(this.$container);
        this.addCloseIcon();
        return this;
    }

    setAddress(address) {
        'use strict';
        this.clearAddress();
        this.$searchInput.val(address);
        return this;
    }

    setLanguage(language) {
        'use strict';
        this.language = language;
        return this;
    }

    setCountry(country) {
        'use strict';
        this.country = country;
        return this;
    }

    setProfileName(profileName) {
        'use strict';
        this.addressProfile = profileName;
        return this;
    }
    setLimit(limit) {
        'use strict';
        this.limit = limit;
        return this;
    }

    setGeographicAddress(geographicAddress) {
        'use strict';
        this.geographicAddress = geographicAddress;
        return this;
    }

    setVanityMode(vanityMode) {
        'use strict';
        this.vanityMode = vanityMode;
        return this;
    }

    setAddressElements(addressElements) {
        'use strict';
        this.addressElements = addressElements;
        return this;
    }

    setDisplayBusinessListings(displayBusinessListings) {
        'use strict';
        this.displayBusinessListings = displayBusinessListings;
        return this;
    }

    showAutocomplete() {
        'use strict';
        this.$searchInput.trigger('keyup');
        return this;
    }

    clearAddress() {
        'use strict';
        this.$searchInput.val('');
        if (this.$.isFunction(this.settings.onClear)) {
            this.settings.onClear.call(this);
        }
        return this;
    }

    getLabel(labelName) {
        'use strict';
        var label = '';
        var isEnglish = this.language.toUpperCase() === Utils.languages().en.code;

        switch (labelName) {
        case 'placeHolder':
            label = isEnglish ? this.settings.placeHolderLabel : this.settings.placeHolderLabel_ga;
            break;
        case 'searchButton':
            label = isEnglish ? this.settings.searchButtonLabel : this.settings.searchButtonLabel_ga;
            break;
        case 'optionsFound':
            label = isEnglish ? this.settings.optionsFoundLabel : this.settings.optionsFoundLabel_ga;
            break;
        case 'incompleteAddress':
            label = isEnglish ? this.settings.incompleteAddressLabel : this.settings.incompleteAddressLabel_ga;
            break;
        case 'partialAddress':
            label = isEnglish ? this.settings.partialAddressLabel : this.settings.partialAddressLabel_ga;
            break;
        case 'nuaAddressFound':
            label = isEnglish ? this.settings.nuaAddressFoundLabel : this.settings.nuaAddressFoundLabel_ga;
            break;
        case 'noResultFound':
            label = isEnglish ? this.settings.noResultFoundLabel : this.settings.noResultFoundLabel_ga;
            break;
        case 'noEircodeAppended':
            label = isEnglish ? this.settings.noEircodeAppendedLabel : this.settings.noEircodeAppendedLabel_ga;
            break;
        case 'eircodeNotValidated':
            label = isEnglish ? this.settings.eircodeNotValidatedLabel : this.settings.eircodeNotValidatedLabel_ga;
            break;
        case 'addressFound':
            label = isEnglish ? this.settings.addressFoundLabel : this.settings.addressFoundLabel_ga;
            break;
        case 'inputRequired':
            label = isEnglish ? this.settings.inputRequiredLabel : this.settings.inputRequiredLabel_ga;
            break;
        case 'addressTab':
            label = isEnglish ? this.settings.addressTabLabel : this.settings.addressTabLabel_ga;
            break;
        case 'businessTab':
            label = isEnglish ? this.settings.businessTabLabel : this.settings.businessTabLabel_ga;
            break;
        case 'back':
            label = isEnglish ? this.settings.backLabel : this.settings.backLabel_ga;
            break;
        }

        return label;
    }

    setLabel(labelName, text) {
        'use strict';
        var isEnglish = this.language.toUpperCase() === Utils.languages().en.code//this.languages.en.code;

        this.settings[labelName] = text;

        switch (labelName) {
        case 'placeHolderLabel':
            if (isEnglish === true && this.$searchInput !== undefined) {
                this.$searchInput.attr('placeholder', text);
            }
            break;
        case 'placeHolderLabel_ga':
            if (isEnglish === false && this.$searchInput !== undefined) {
                this.$searchInput.attr('placeholder', text);
            }
            break;
        case 'searchButtonLabel':
            if (isEnglish === true && this.$searchButton !== undefined) {
                this.$searchButton.html(text);
            }
            break;
        case 'searchButtonLabel_ga':
            if (isEnglish === false && this.$searchButton !== undefined) {
                this.$searchButton.html(text);
            }
            break;
        case 'backLabel':
            if (isEnglish === true && this.$backLink !== undefined) {
                this.$backLink.html(text);
            }
            break;
        case 'backLabel_ga':
            if (isEnglish === false && this.$backLink !== undefined) {
                this.$backLink.html(text);
            }
            break;
        }
    }

    checkResponseContainsError(response) {
        'use strict';
        var includesError = false;

        if (response.errors) {
            var errorMessage = response.errors[0];

            this.displayErrorMessage(errorMessage.message);
            if (this.$.isFunction(this.settings.onLookupError)) {
                this.settings.onLookupError.call(this, response);
            }
            includesError = true;
        }
        return includesError;
    }

    static defaults() {
        return {
            // control settings
            key: '',
            language: 'EN',
            country: 'IE',
            geographicAddress: false,
            vanityMode: false,
            addressElements: false,
            addressProfile: '',
            optionsLimit: '-1',
            autocomplete: true,
            autocompleteMinChars: 3,
            width: 'auto',
            hoverOptionPanel: false,
            displayBusinessListings: true,
            defaultSearch: false,

            // English Default Messages
            placeHolderLabel : "Enter Full Address or Postcode",
			searchButtonLabel : "Search",
			optionsFoundLabel: "Please select an option below",
			incompleteAddressLabel: "Too little information, please enter more details.",
			partialAddressLabel: "Couldn't find [unmatched] try again or enter address manually below.",
			nuaAddressFoundLabel: "We’ve found the address, please add your Postcode in the text box below if you know it",
			noResultFoundLabel : "No search results have been found.",
			noEircodeAppendedLabel: "Address found, but no Postcode Available.",
			eircodeNotValidatedLabel:"Eircode found, but address not validated",
			addressFoundLabel: "Postcode Found, address populated below.",
			inputRequiredLabel: "Enter a full address or Postcode to begin your search.",
			errorMessageLabel: "Sorry, an unexpected error has occurred.",
			addressTabLabel : "Address",
			businessTabLabel : "Business",
			backLabel : "Back",

            // Irish Default Messages
            placeHolderLabel_ga : "Cuir isteach seoladh iomlán nó Eircode",
			searchButtonLabel_ga : "Cuardaigh",
			optionsFoundLabel_ga: "Roghnaigh ceann de na roghanna seo thíos le do thoil:",
			incompleteAddressLabel_ga: "Ár leithscéal, tá tuilleadh eolais at teastáil uainn",
			partialAddressLabel_ga: "Ní rabhamar in ann an seoladh a mheaitseáil. Seiceáil an seoladh, le do thoil, agus cuardaigh arís.",
			nuaAddressFoundLabel_ga: "Táimid tar éis a fuair an seoladh , le do thoil cuir do Eircode sa bhosca thíos má tá a fhios agat é",
			noResultFoundLabel_ga : "Gan torthaí cuardaigh a shuífear",
			noEircodeAppendedLabel_ga: "Seoladh aimsíodh, ach níl an seoladh bailíochtaithe",
			eircodeNotValidatedLabel_ga: "Eircode fuair, ní aghaidh a thabhairt ar bhailíochtú",
			addressFoundLabel_ga: "Eircode Aimsíodh , seoladh daonra thíos",
			inputRequiredLabel_ga: "Cuir isteach seoladh iomlán nó Eircode le tús a chur le do chuardach.",
			errorMessageLabel_ga: "Tá brón orainn , tá earráid gan choinne a tharla",
			addressTabLabel_ga : "Seoladh",
			businessTabLabel_ga : "Gnólacht",
			backLabel_ga : "Siar",

            // Control CSS Classes
            containerClass: 'autoaddress-control',
            searchButtonClass: 'autoaddress-button',
            searchInputClass: 'autoaddress-text-box',
            optionsContainerClass: 'autoaddress-options-container',
            optionsListClass: 'autoaddress-options-list',
            optionsItemClass: 'autoaddress-options-item',
            errorMessageContainerClass: 'autoaddress-options-msg error',
            infoMessageContainerClass: 'autoaddress-options-msg info',
            successMessageContainerClass: 'autoaddress-options-msg success',
            searchingClass: 'autoaddress-circle-spinner',
            loadingAnimationClass: 'autoaddress-loader',
            hideButtonTextClass: 'btn-hide-text',
            autocompleteContainer: 'autoaddress-autocomplete',
            autocompleteSuggestion: 'autoaddress-suggestion',
            backLinkClass: 'autoaddress-back-link',
            closeIconClass: 'autoaddress-close-msg',
            multiTabsClass: 'autoaddress-options-tabs',
            multiTabPaneClass: 'autoaddress-options-tab-pane',

            // webservice settings
            api_domain: '//__thisservername__/2.0',

            // Callbacks
            onInitialize: function() {
            },
            onSearchStart: function() {
            },
            onAddressFound: function() {
            },
            onSearchCompleted: function() {
            },
            onAutoCompleteSelected: function() {
            },
            onLookupError: function() {
            },
            onChange: function() {
            },
            onClear: function() {
            },
            onFocus: function() {
            }
        };
    }
}
export {Autoaddress};
